import { Component, OnInit,ViewChild } from '@angular/core';
import { NavBarService } from '../../../../services/nav-bar.service';
import { IconBarService } from '../../../../services/icon-bar.service';
import { MenuService } from '../../../../services/menu.service';
import { BaseDisplayComponent } from '../../base-display/base-display.component';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuNode } from '../../../../classes';
@Component({
  selector: 'app-codeabfrage',
  templateUrl: './codeabfrage.component.html',
  styleUrls: ['./codeabfrage.component.scss']
})
export class CodeabfrageComponent implements OnInit {
	@ViewChild(BaseDisplayComponent) display:BaseDisplayComponent;
	min:number=0;
	max:number=99;
	value:number=0;
	b():string{
		return (this.value < 10)?('0'+this.value):(""+this.value);
	}
	s():string{
		return '';
	}
	unit():string{
		return '';
	}
	handler(event){
		switch(event){
			case 'up':{
				this.value++;
				if(this.value > this.max){
					this.value = this.min;
				}
				return;
			}
			case 'down':{
				this.value--;
				if(this.value < this.min){
					this.value = this.max;
				}
				return;
			}
			case 'back':{
				console.log("Back-Event registered.");
				let node = this.node.getBackTargetNode();
				if(node){
					this.menuService.goto(node);
					return;
				}
				console.log("nevermind...");
				return;
			}
			case 'menu':{
				this.menuService.goto('ecoMode');
				return;
			}
			case 'confirm':{
				if(this.node.hasTarget()){
					if([35,96].includes(this.value)){
						this.menuService.goto(this.node.getTargetNode());
						return;
					}else{
						this.display.blink();
					}
				}
				let target = undefined;
				if([0,96,35].includes(this.value)){
					this.ioService.deviceInfo().getScale('last_code').setCurrentValue(this.value);
					this.ioService.startCodeReset();
				}
				switch(this.value){
					case 0:{
						if(!this.menuService.hasParameter('setup')){
							this.menuService.goto('energiedaten');
						}else{
							this.display.blink();
						}
						return;
					}
					case 96:
					case 35:{
						this.menuService.goto('fachhandwerkerebene');
						return;
					}
					default:{
						this.display.blink();
						return;
					}
				}
				return;
			}
			default:{
				return;
			}
		}
	}
  constructor(
  	private navBar:NavBarService,
  	private iconBar:IconBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService
  ) {
  }

  subscription:any=undefined;
  node:MenuNode=undefined;
  ngOnInit() {
  	this.node = this.menuService.getCurrentNode();
  	if(this.node.getIdentifier() == 'fachhandwerker-codeabfrage'){
  		this.navBar.enableAll();
  		this.iconBar.enable();
		this.iconBar.evaluate();

  		this.navBar.blink('installer');
  	}
  	this.subscription = this.ioService.inputs.events$.subscribe(
  		(event)=>{
  			this.handler(event);
  		}
	);
	this.value = this.ioService.deviceInfo().getScale('last_code').getCurrentValue();
  }
  ngOnDestroy(){

  	if(this.subscription){
  		this.subscription.unsubscribe();
  	}
  }

}
